import { trigger, style, animate, transition } from '@angular/animations';

export let animations = [
  trigger(
    'fadeAnimation', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('500ms', style({ opacity: 1 }))
    ]),
    transition(':leave', [
      style({ opacity: 1 }),
      animate('300ms', style({ opacity: 0 }))
    ])
  ]
  )
]

export let fadeAnimation = [
  trigger(
    'fadeAnimation', [
    transition(':enter', [
      style({ opacity: 0, maxHeight: '0px' }),
      animate('500ms', style({ opacity: 1, maxHeight: '300px' }))
    ]),
    transition(':leave', [
      style({ opacity: 1, maxHeight: '300px' }),
      animate('200ms', style({ opacity: 0, maxHeight: '0px' }))
    ])
  ]
  )
]
